var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UsersAdminView } from "./view/adminUsers.view";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useUsersData } from "./hooks/useUsersData";
import { usePagination } from "./hooks/usePagination";
import { CreateUser } from "./resources/createUser/createUser";
import { useIdentificationTypeData } from "./hooks/useIdentificationTypeData";
import { UserCatalogData } from "./hooks/userCatalogData";
import { DataFormUsers } from "./constanst/adminUsersDTO";
import { useBranchData } from "./hooks/useBranchData";
import { useClientData } from "./hooks/useClientData";
import { useCreateOrEditUser } from "./hooks/useCreateOrEditUser";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { EditAddRoles } from "./resources/roles/editAddRoles";
import { useDataRoles } from "./hooks/useDataRoles";
import { useAssignRoles } from "./hooks/useAssignRoles";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { useUserActions } from "./hooks/useUserActions";
import { useSuccessHandlers } from "./hooks/useSuccessHandlers";
export var UsersAdmin = function () {
    var _a = useState(false), openDrawer = _a[0], setOpenDrawer = _a[1];
    var _b = useState(false), openModalAddNewUser = _b[0], setOpenModalAddNewUser = _b[1];
    var _c = useState([]), rolesRows = _c[0], setRolesRows = _c[1];
    var _d = useState([]), filtersApplied = _d[0], setFiltersApplied = _d[1];
    var _e = useState(DataFormUsers), dataFormUsers = _e[0], setDataFormUsers = _e[1];
    var _f = useState(""), userId = _f[0], setUserId = _f[1];
    var _g = useState(false), openModalEditRoles = _g[0], setOpenModalEditRoles = _g[1];
    var _h = useState(""), userName = _h[0], setUserName = _h[1];
    var _j = useState([]), assignedRoles = _j[0], setAssignedRoles = _j[1];
    var _k = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _k[0], setSeeToast = _k[1];
    var _l = useUsersData(filtersApplied), usersData = _l.usersData, loadingUser = _l.loadingUser, countData = _l.countData, setPage = _l.setPage, page = _l.page, setLimit = _l.setLimit, limit = _l.limit, callUsers = _l.callUsers, setSearchQuery = _l.setSearchQuery;
    var _m = usePagination(setPage, setLimit, callUsers), onChangePage = _m.onChangePage, onChangeLimit = _m.onChangeLimit;
    var _o = useIdentificationTypeData(), errorIdentificationType = _o.errorIdentificationType, loadingIdentificationType = _o.loadingIdentificationType, identificationTypesList = _o.identificationTypesList;
    var _p = UserCatalogData(), genderList = _p.genderList, errorGetCatalogsType = _p.errorGetCatalogsType, loadingGetCatalogsType = _p.loadingGetCatalogsType;
    var _q = useBranchData(), listBranch = _q.listBranch, loadingBranches = _q.loadingBranches, errorBranches = _q.errorBranches;
    var _r = useClientData(), companyList = _r.companyList, loadingOneClient = _r.loadingOneClient, errorOneClient = _r.errorOneClient;
    var _s = useDataRoles(), rolesList = _s.rolesList, errorRol = _s.errorRol, loadingRol = _s.loadingRol;
    var _t = useCreateOrEditUser(userId), isEdit = _t.isEdit, setIsEdit = _t.setIsEdit, handleSubmitUser = _t.handleSubmitUser, resetTriggers = _t.resetTriggers, loadingSubmit = _t.loading, errorSubmit = _t.error, responseSubmit = _t.response;
    var _u = useAssignRoles(), resetTriggerPutRoles = _u.resetTriggerPutRoles, handleAssignRoles = _u.handleAssignRoles, loadingUserPutRol = _u.loadingUserPutRol, responseUserPutRol = _u.responseUserPutRol, errorUserPutRol = _u.errorUserPutRol;
    var _v = useUserActions({
        setDataFormUsers: setDataFormUsers,
        setUserId: setUserId,
        setIsEdit: setIsEdit,
        setOpenModalAddNewUser: setOpenModalAddNewUser,
        setUserName: setUserName,
        setOpenDrawer: setOpenDrawer,
        setRolesRows: setRolesRows,
        setAssignedRoles: setAssignedRoles,
    }), handleResetFormToInitialState = _v.handleResetFormToInitialState, onOptionsCardClick = _v.onOptionsCardClick;
    useSuccessHandlers({
        responseSubmit: responseSubmit,
        responseUserPutRol: responseUserPutRol,
        isEdit: isEdit,
        rolesRows: rolesRows,
        setOpenModalAddNewUser: setOpenModalAddNewUser,
        setOpenModalEditRoles: setOpenModalEditRoles,
        setSeeToast: setSeeToast,
        resetTriggers: resetTriggers,
        resetTriggerPutRoles: resetTriggerPutRoles,
        callUsers: callUsers,
    });
    useEffect(function () {
        if (listBranch && companyList) {
            setDataFormUsers(function (prevState) {
                var _a, _b;
                return (__assign(__assign({}, prevState), { branch: ((_a = listBranch[0]) === null || _a === void 0 ? void 0 : _a.id) || "", company: ((_b = companyList[0]) === null || _b === void 0 ? void 0 : _b.id) || "" }));
            });
        }
    }, [listBranch, companyList]);
    useErrorHandling({
        errorIdentificationType: errorIdentificationType,
        errorGetCatalogsType: errorGetCatalogsType,
        errorBranches: errorBranches,
        errorOneClient: errorOneClient,
        errorRol: errorRol,
        errorUserPutRol: errorUserPutRol,
        errorSubmit: errorSubmit,
        setSeeToast: setSeeToast,
    });
    var loading = loadingUser ||
        loadingIdentificationType ||
        loadingGetCatalogsType ||
        loadingBranches ||
        loadingOneClient ||
        loadingSubmit ||
        loadingRol ||
        loadingUserPutRol;
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loading, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Guardando usuario..." }), _jsx(CreateUser, { openModal: openModalAddNewUser, setOpenModal: setOpenModalAddNewUser, identificationTypesList: identificationTypesList, genderList: genderList, dataFormUsers: dataFormUsers, listBranch: listBranch, companyList: companyList, handleSubmitUser: handleSubmitUser, isEdit: isEdit }), _jsx(EditAddRoles, { openModalEditRoles: openModalEditRoles, setOpenModalEditRoles: setOpenModalEditRoles, userName: userName, assignedRoles: assignedRoles, rolesList: rolesList, userId: userId, handleAssignRoles: handleAssignRoles }), _jsx(UsersAdminView, { openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, onOptionsCardClick: onOptionsCardClick, usersData: usersData, countData: countData, limit: limit, rolesRows: rolesRows, onChangePage: onChangePage, onChangeLimit: onChangeLimit, page: page, setFiltersApplied: setFiltersApplied, setOpenModalAddNewUser: setOpenModalAddNewUser, setIsEdit: setIsEdit, handleResetFormToInitialState: handleResetFormToInitialState, setOpenModalEditRoles: setOpenModalEditRoles, setSearchQuery: setSearchQuery })] }));
};
